/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-18 09:35:00
 */

import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
import "videojs-flvjs-es6";
import "videojs-flash";

import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import './videoMonitor.less';
import Tab from 'src/components/tab/tab';
import DiskConfigApi from 'src/pages/systemConfig/diskConfig/api/diskConfigApi';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import EnumStationType from 'src/enums/enumStationType';
let bem = createBEM('video-monitor');

export interface VideoMonitorPropsI { }
export interface FormDataI {
    NvrId: Number;
}

@Component
export default class VideoMonitor extends Vue.Component<VideoMonitorPropsI> {
    deviceId: number = -1;
    currentType: 1 | 0 = 0;
    formData: FormDataI = {
        NvrId: null,
    };
    nvrinfo: Array = [];
    dict: any = {}
    type: number = null;


    mounted() {
        var newVideo = document.createElement("div");//创建一个标签		
		newVideo.innerHTML = '<video id='+ "videoPlayer" +' width="100%" height="100%" class="video-js vjs-big-play-centered vjs-fluid" controls preload="auto"></video>';
		var Fid = document.getElementById("fid");//通过id号获取newVideo的父节点（也就是上一级的节点）
		Fid.appendChild(newVideo);//把创建的节点newVideo添加到父节点中；

        this.deviceId = +this.$route.query.id;
        Bus.$on(Events.StationChange, this.stationChange);
        //this.change();
        //查询硬盘机信息
        this.getNvrInfo();
        this.autoPushStream();
    }
    async getNvrInfo() {
        let { code, data } = await DiskConfigApi.deviceIdByNvr({ "device_id": this.deviceId });
        data["data_info"].forEach(element => {
            var dict = {}
            dict[element.id] = element
            this.nvrinfo.push(dict)
        });
    }

    async autoPushStream() {
        try {
            let stationTypeId = EnumStationType.findCode(this.$route.params.type).getId();
            let { code, data } = await DiskConfigApi.searchList({
                device_id: this.deviceId + '',
                nvr_type: 1,
                type: stationTypeId,
                page_size: 100,
                page_index: 1,
            } as any);
            if (code !== 0 || !data.data_info || data.data_info.length === 0) {
                return;
            }
            let nvr = data.data_info[0];
            let channelsRes = await DiskConfigApi.searchChanel({ dvr_id: nvr.id });
            if (channelsRes.code !== 0) return;
            let channels = channelsRes.data
                .filter(i => i.status === 1)
                .map(i => ({ id: i.channel_num, name: i.channel_num + '' }));
            if (channels.length === 0) return;
            for (let channel of channels) {
                await DiskConfigApi.getAddress({
                    type: 1,
                    device_id: this.deviceId,
                    nvr_user_id: nvr.nvr_user_id,
                    deviceserial: nvr.deviceserial,
                    channel_total_count: nvr.channel_total_count,
                    channelNo: channel.id,
                    ezopen_type: 1,
                    quality: 1,
                    expireTime: 300,
                    chanels: channels,
                    datatime: [],
                } as any);
            }
        } catch (e) {
            // 静默失败，用户仍可手动开启推流
        }
    }

    player: any;
    lcplayer: null

    currentChannelNum: string = '';

    dataSource: { live_url: string, channel_num: string }[] = [];

    destroyPlayer() {
        if (!this.player) { return }
        this.player.pause();
        this.player.unload();
        this.player.detachMediaElement();
        this.player.destroy();
        this.player = null;
    }

    get currentUrl() {
        let item = this.dataSource.find(i => i.channel_num === this.currentChannelNum)
        //return item?item.live_url:''
        return item
    }

    async change() {
        if (this.formData.NvrId == null) {
            return;
        }
        let { code, data } = await DiskConfigApi.searchLive({ device_id: this.deviceId, type: this.currentType, dvr_id: -2, nvr_id: this.formData.NvrId });
        if (code === 0) {
            if (flvjs.isSupported()) {
                this.dataSource = data.data_info || [];
                if (data.data_info.length === 0) {
                    this.destroyPlayer();
                    return
                }
                this.nvrinfo.forEach(element => {
                    if (element.hasOwnProperty(this.formData.NvrId)) {
                        this.type = element[this.formData.NvrId].type;
                    }
                });
                this.currentChannelNum = data.data_info[0].channel_num
                if (this.type == 2) {
                    this.getVideoHls(this.currentUrl.url)
                }
                else if (this.type == 1) {
                    // this.getVideoFlv(this.currentUrl.url);
                    this.getVideoHls(this.currentUrl.url);
                }
                // else {
                //     if (data.data_info[0].protocol == 1) {
                //         this.getVideoHls(this.currentUrl.live_url);
                //     }
                //     else if (data.data_info[0].protocol == 2) {
                //         this.getVideoFlv(this.currentUrl.live_url);
                //     }
                // }
            }
        }
    }
    @Watch('currentUrl')
    urlChange() {
        this.player.dispose();
        this.player = null;
        var newVideo = document.createElement("div");//创建一个标签		
		newVideo.innerHTML = '<video id='+ "videoPlayer" +' width="100%" height="100%" class="video-js vjs-big-play-centered vjs-fluid" controls preload="auto"></video>';
		var Fid = document.getElementById("fid");//通过id号获取newVideo的父节点（也就是上一级的节点）
		Fid.appendChild(newVideo);//把创建的节点newVideo添加到父节点中；
        if (this.type == 1) {
            // this.getVideoFlv(this.currentUrl.url);
            this.getVideoHls(this.currentUrl.url);
        }
        else if (this.type == 2) {
            this.getVideoHls(this.currentUrl.url);
        }
    }


    playVideoByUrl(url: string) {
        this.destroyPlayer();
        var videoElement = document.getElementById('videoElement');
        this.player = flvjs.createPlayer({
            type: 'flv',
            isLive: true,
            hasAudio: false,
            hasVideo: true,
            enableStashBuffer: true,
            url: url
        });
        this.player.attachMediaElement(videoElement);
        this.player.load();
        this.player.play();
    }

    getVideoHls(url: string) {
        var option={
            autoplay: true, // 设置自动播放
            controls: true, // 显示播放的控件
            aspectRatio: "15:7"
        };
        this.player = Videojs('videoPlayer',option,function onPlayerReady(){
            var myPlayer = this;
            myPlayer.src({src: url, type: "application/x-mpegURL"});
            this.play();
        });
    }

    getVideoFlv(url: string) {
        var option={
            autoplay: true, // 设置自动播放
            controls: true, // 显示播放的控件
            aspectRatio: "15:7"
        };
        this.player = Videojs('videoPlayer',option,function onPlayerReady(){
            var myPlayer = this;
            myPlayer.src({src: url, type: "video/x-flv"});
            this.play();
        });
    }

    async stationChange(data: StationListDOI.RowDataI) {
        this.deviceId = data.id;
        this.nvrinfo = [];
        this.formData.NvrId = null;
        await this.getNvrInfo();
        await this.autoPushStream();
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
        this.player.dispose();
    }
    //{ value: 1, name: '回放' }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('top')}>
                    <Tab
                        dataSource={[{ value: 0, name: '直播' },]}
                        v-model={this.currentType}
                    />
                    <i-form labelWidth={100} style="width:60%">
                        <form-item v-if={this.deviceId != -1} required label="硬盘机" prop="NvrId" style="display: inline-block;width:45%">
                            <EntitySelect
                                type={EnumEntity.NvrInfo.getId()}
                                searchParams={{ "device_id": this.deviceId }}
                                v-model={this.formData.NvrId}
                                on-change={() => {
                                    this.change()
                                }}
                            />
                        </form-item>
                        <form-item
                            label="通道"
                            style="display: inline-block;width:45%;"
                        >
                            <i-select
                                placeholder="请选择通道"
                                clearable={true}
                                v-model={this.currentChannelNum}>
                                {
                                    this.dataSource.map((item, index) => <i-option value={item.channel_num} key={item.channel_num}>{'通道' + item.channel_num}</i-option>)
                                }
                            </i-select>
                        </form-item>
                    </i-form>
                </div>
                <div class={bem('video')} id= "fid">
                   
                </div>
            </div>
        );
    }
}
